import { Divider } from "@mui/material";
import { Link } from "react-router-dom";
export default function Policy() {
  return (
    <div className="w-full">
      <div className="w-full mx-auto container  bg-white px-[30px] py-[30px] pt-24 md:pt-28 ">
        <h1 className="text-3xl font-bold text-blue-600 mb-6 text-center">
          CHÍNH SÁCH BẢO MẬT
        </h1>
        <p className="text-gray-700 mb-4">
          Blue Rise cam kết bảo vệ sự riêng tư và bảo mật thông tin cá nhân của
          bạn khi truy cập website{" "}
          <Link to="mailto:http://bluerise.com.vn">bluerise.com.vn</Link> Vui
          lòng đọc chính sách này để hiểu rõ cách chúng tôi thu thập, sử dụng và
          quản lý thông tin của bạn.
        </p>

        <h2 className="text-2xl font-semibold text-gray-800 mt-6 mb-4">
          1. Phạm vi thu thập thông tin
        </h2>
        <ul className="list-disc list-inside text-gray-700 mb-4">
          <li>Đăng ký tài khoản trên website.</li>
          <li>Sử dụng các dịch vụ hoặc tính năng cung cấp trên trang web.</li>
          <li>Liên hệ hỗ trợ qua biểu mẫu trên website.</li>
        </ul>
        <p className="text-gray-700 mb-4">
          Thông tin thu thập bao gồm: Tên, email, số điện thoại, và các thông
          tin cần thiết khác phục vụ cho việc cung cấp dịch vụ. Thông tin truy
          cập (như địa chỉ IP, trình duyệt, thời gian truy cập, trang đã xem).
        </p>

        <h2 className="text-2xl font-semibold text-gray-800 mt-6 mb-4">
          2. Mục đích sử dụng thông tin
        </h2>
        <p className="text-gray-700 mb-4">
          Thông tin thu thập từ bạn được sử dụng vì các mục đích sau:
        </p>
        <ul className="list-disc list-inside text-gray-700 mb-4">
          <li>
            Cung cấp dịch vụ, tính năng và hỗ trợ bạn trong quá trình sử dụng
            website.
          </li>
          <li>Nâng cao chất lượng trải nghiệm của người dùng.</li>
          <li>
            Gửi các thông báo quan trọng, nhập vai giao dịch, hoặc khuyến mãi.
          </li>
          <li>Đảm bảo an toàn và ngăn chặn các hoạt động gian lận.</li>
        </ul>

        <h2 className="text-2xl font-semibold text-gray-800 mt-6 mb-4">
          3. Chia sẻ thông tin
        </h2>
        <p className="text-gray-700 mb-4">
          Chúng tôi không bán, trao đổi hoặc cung cấp thông tin cá nhân của bạn
          cho bên thứ ba, trừ khi:
        </p>
        <ul className="list-disc list-inside text-gray-700 mb-4">
          <li>Được bạn đồng ý.</li>
          <li>
            Tuân thủ theo quy định của pháp luật hoặc yêu cầu từ cơ quan chức
            năng.
          </li>
          <li>
            Các bên cung cấp dịch vụ liên quan đến việc duy trì và vận hành
            website.
          </li>
        </ul>

        <h2 className="text-2xl font-semibold text-gray-800 mt-6 mb-4">
          4. Lưu trữ và bảo mật thông tin
        </h2>
        <p className="text-gray-700 mb-4">
          Thông tin cá nhân của bạn được lưu trữ trên hệ thống đảm bảo bảo mật
          cao và chỉ được truy cập bởi nhân viên có thẩm quyền. Chúng tôi sử
          dụng các biện pháp kỹ thuật và tổ chức để ngăn chặn truy cập trái
          phép, mất mát hoặc rò rỉ thông tin.
        </p>

        <h2 className="text-2xl font-semibold text-gray-800 mt-6 mb-4">
          5. Quyền lợi của người dùng
        </h2>
        <p className="text-gray-700 mb-4">
          Bạn có quyền truy cập, chỉnh sửa hoặc yêu cầu xóa thông tin cá nhân
          của mình. Nếu có bất kỳ vấn đề nào liên quan đến bảo mật, vui lòng
          liên hệ chúng tôi qua email:{" "}
          <Link
            to="mailto:support@bluerise.com.vn"
            className="text-blue-500 underline"
          >
            support@bluerise.com.vn
          </Link>
        </p>

        <h2 className="text-2xl font-semibold text-gray-800 mt-6 mb-4">
          6. Thay đổi chính sách
        </h2>
        <p className="text-gray-700 mb-4">
          Blue Rise có quyền thay đổi nội dung chính sách bảo mật bất kỳ lúc nào
          mà không cần thông báo trước. Bạn có trách nhiệm thường xuyên kiểm tra
          để đảm bảo hiểu rõ và tuân theo chính sách bảo mật được đề cập đến
          trong phần này.
        </p>
      </div>
    </div>
  );
}
